module.exports = __webpack_public_path__ + "static/img/vip-desc@2x.3e84957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-desc@2x.png
// module id = vAeJ
// module chunks = 1